import React from 'react';
import { CircledExclamationPointIcon } from '@repo/icons';
import { supportEmailProps } from '@repo/utils/helpers/preferred-email-client';
import ViewWrapper from './ViewWrapper';

export default function LoginError() {
  return (
    <ViewWrapper
      icon={<CircledExclamationPointIcon />}
      headline="Clay Community Login Failed"
      message={
        <>
          An error occurred. Please try again or
          <br />
          <a {...supportEmailProps({ subject: 'Issue logging into Clay Community' })}>
            reach out to us
          </a>{' '}
          if you need assistance.
        </>
      }
      button={{
        text: 'Try again',
        onClick: () => (window.location.href = 'https://community.clay.earth'),
      }}
    />
  );
}
